import React from 'react';
import { SelectInput, useGetList } from 'react-admin';

export const CustomSelect = ({
  source,
  optionValue,
  optionText,
  route,
  choiceAddField,
  isDisabled = false,
  filter,
  customDefaultValue = false,
  defaultValueField = false,
  ...props
}) => {
  // якщо є фільтр додається в параметри useGetList
  const params = [{ page: 1, perPage: 1000 }, null];
  if (filter) {
    params[2] = { ...filter };
  }

  // eslint-disable-next-line prefer-const
  let { data, isLoading, error } = useGetList(route, ...params);

  if (isLoading) {
    return <p>Loading</p>;
  }

  // формую список для селекта
  const choices = Object.keys(data).map((el) => {
    const element = data[el];
    const choice = {
      id: element.id,
      [optionText]: element[optionText],
      [optionValue]: element[optionValue],
    };
    if (choiceAddField) {
      if (!Number.isNaN(Number(element[choiceAddField]))) {
        element[choiceAddField] = Number(element[choiceAddField]).toFixed(2);
      }
      choice[choiceAddField] = element[choiceAddField];
    }
    return choice;
  });

  if (choices.length === 0) {
    error = 'No data';
  }

  // додаю додаткові поля якщо вони є
  const getOptionText = (choice) => `${choice[optionText]} ${
    choice[choiceAddField]
      ? `(${choiceAddField}: ${choice[choiceAddField]})`
      : ''
  }`;

  // знаходжу початкове значення
  let defaultValue = '';
  if (customDefaultValue && defaultValueField) {
    const val = choices.find((el) => el[defaultValueField] === customDefaultValue);
    defaultValue = val?.[optionValue];
  }

  return (
    <SelectInput
      {...props}
      label={error || source.charAt(0).toUpperCase() + source.slice(1)}
      error={error}
      disabled={isDisabled || error}
      style={{ width: '256px' }}
      source={source}
      choices={choices}
      optionValue={optionValue}
      optionText={getOptionText}
      defaultValue={defaultValue}
    />
  );
};
